import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private http: HttpClient, private router: Router) {}

    public getToken() {
        return localStorage.getItem('token');
    }

    login(email: string, password: string) {
        return this.http
            .post(`${(window as any).__env.apiUrl}/auth/login`, {
                email: email,
                password: password,
                old_bo: true
            })
            .pipe(
                catchError((error) => {
                    return error;
                }),
                tap((data: any) => {}),
                map((data: any) => {
                    return data;
                })
            );
    }

    register(
        email: string,
        firstname: string,
        name: string,
        username: string,
        password: string
    ) {
        return this.http
            .post(`${(window as any).__env.apiUrl}/auth/register`, {
                email: email,
                password: password,
                firstname: firstname,
                name: name,
                username: username,
            })
            .pipe(
                catchError((error) => {
                    return error;
                }),
                tap((data: any) => {}),
                map((data: any) => {
                    return data;
                })
            );
    }

    forgotPassword(email: string) {
        return this.http
            .post(`${(window as any).__env.apiUrl}/users/reset-password`, {
                email: email,
            })
            .pipe(
                catchError((error) => {
                    console.log(error);
                    if (error.status === 404) {
                        // Return an Observable that emits a default value
                        return of(error.error.message);
                    }
                    return error;
                }),
                tap((data: any) => {}),
                map((data: any) => {
                    return data;
                })
            );
    }

    resetPassword(user_id: string, password: string, token: string) {
        return this.http
            .post(`${(window as any).__env.apiUrl}/users/new-password`, {
                password: password,
                user_id: user_id,
                token: token,
            })
            .pipe(
                catchError((error) => {
                    console.log(error);
                    if (error.status === 404) {
                        // Return an Observable that emits a default value
                        return of(error.error.message);
                    }
                    return error;
                }),
                tap((data: any) => {}),
                map((data: any) => {
                    return data;
                })
            );
    }

    addToWaitingList(email: string) {
        return this.http
            .post(`${(window as any).__env.apiUrl}/users/waiting-list`, {
                email: email,
            })
            .pipe(
                catchError((error) => {
                    return of(error);
                }),
                tap((data: any) => {}),
                map((data: any) => {
                    return data;
                })
            );
    }

    loginWithSSO(user: any, UUID: string) {
        let username;
        if (user.additionalUserInfo.profile.given_name && user.additionalUserInfo.profile.family_name) {
          username = user.additionalUserInfo.profile.given_name + '_' + user.additionalUserInfo.profile.family_name.charAt(0);
        } else {
          username = user.additionalUserInfo.profile.given_name
        }
    
        const body = {
            idToken: user.user._delegate.accessToken,
            email: user.additionalUserInfo.profile.email ? user.additionalUserInfo.profile.email : '',
            firstname: user.additionalUserInfo.profile.given_name ? user.additionalUserInfo.profile.given_name : '',
            name: user.additionalUserInfo.profile.family_name ? user.additionalUserInfo.profile.family_name : '',
            username: username,
            uuid: UUID,
            old_bo: true
        };
    
        const url = (window as any).__env.apiUrl;
    
        return this.http
          .post(`${url}/auth/google`, body) // Utilisation de la méthode POST
          .pipe(
            catchError((error: any) => {
                return of(error);
                }),
            tap((data: any) => {}),
            map((data: any) => {
                return data;
            })
          );
    }

    public async logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('public_token');
        localStorage.removeItem('isSuperAdmin');
        localStorage.removeItem('isSupervisor');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('isEditor');
        localStorage.removeItem('isReader');
        localStorage.removeItem('currentCompany');
        localStorage.removeItem('currentOrganisation');
        window.location.reload();
    }
}
